<div class="hover-card border border-dark p-3 rounded ">
    <ng-content>

    </ng-content>
</div>


